export default "__VITE_ASSET__Djt9bBpD__"